/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateFilters {
    getFixupPrototypeFunction() { return AutomationTemplateFilters.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateFilters>): AutomationTemplateFilters {
        let obj = Object.assign(new AutomationTemplateFilters(), model);
        AutomationTemplateFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateFilters>): AutomationTemplateFilters {
        if (!model) return null;
        return AutomationTemplateFilters.newInstance(<AutomationTemplateFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateFilters) {
        if (!obj) return;

        models.AutomationTemplateFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateFilters): boolean {
        Object.setPrototypeOf(obj, AutomationTemplateFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.from_date === "string") {
            this.from_date = new Date(<string><any>this.from_date);
        }
        if (typeof this.to_date === "string") {
            this.to_date = new Date(<string><any>this.to_date);
        }
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Filter from date
     */
    from_date: Date;

    /**
     * Filter to date
     */
    to_date: Date;

    /**
     * Scope of the template.
     */
    scope: models.AutomationTemplateScope;

    /**
     * Name of the template
     */
    template_name: string;

    /**
     * Free-text search across template name, classification, engine_type, template_type and provider
     */
    search: string;

    /**
     * Include the Sys_ templates behind the inventory resource actions, excluded by default
     */
    include_system_templates: boolean;

    query: models.QueryOperator;

}
